/* eslint-disable max-lines-per-function */
import React, { useEffect, useState, useContext, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { MANAGE_KPI_DASHBOARD } from '../../Constants/strings';
import './manageKpi.scss';
import MultiSelectSearchDropdown from '../../Components/MultiFilterSearch/multiFilterSearch';
import noKpiDataIcon from '../../Assets/images/svg/dar_no_kpi_data.svg';
import {
  fetchVertivalList,
  fetchDepartmentList,
  fetchDesignationList,
  fetchPerformancePeriodList,
} from './Filters/filtersUtil';
import ButtonComponent from '../../Components/Button/button';
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import {
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
} from '@mui/material';
import lottie from 'lottie-web';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { fetchKpiDetails } from './manageKpiUtil';
import KpiPerformanceCycle from './SetKpi/kpiPerformanceCycle';
import { AuthContext } from '../../Contexts/AuthContext';
import { MODULE_NAMES } from '../../Constants/modules';

const ManageKpi = () => {
  const navigate = useNavigate(); // Use the navigate hook
  const [verticalList, setVerticalList] = useState([]);
  const [selectedVertical, setSelectedVertical] = useState([]);
  const [department, setDepartment] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  const [designationList, setDesignationList] = useState([]);
  const [selectedDesignation, setSelectedDesignation] = useState([]);
  const [kpiDetails, setKpiDetails] = useState([]);
  const [expanded, setExpanded] = useState(false);
  const [editTarget, setEditTarget] = useState(false);
  const [noDataMessage, setNoDataMessage] = useState('');
  const [performancePeriodList, setPerformancePeriodList] = useState([]);
  const [selectPerformancePeriod, setSelectPerformancePeriod] = useState([]);
  const [dialogOpen, setDialogOpen] = useState(false);
  const [animationData, setAnimationData] = useState(null);
  const animationContainer = useRef(null);
  const { userProfile } = useContext(AuthContext);
  const permission = userProfile?.permissions
    ? userProfile.permissions[MODULE_NAMES.CONFIGURATION_MANAGE_KPI] || []
    : [];

  const hasAccess = (action) => {
    return permission.includes(action);
  };

  useEffect(() => {
    setNoDataMessage('');
    fetchVertivalList().then(setVerticalList);
    fetchDepartmentList().then(setDepartment);
    fetchDesignationList().then(setDesignationList);
    fetchPerformancePeriodList().then(setPerformancePeriodList);
  }, []);

  const handleVerticalFilter = (event) => {
    setSelectedVertical(event.target.value);
    localStorage.setItem(
      'kpiVertical',
      JSON.stringify(event.target.value),
    );
  };
  const handleDesignationFilter = (event) => {
    setSelectedDesignation(event.target.value);
    localStorage.setItem(
      'kpiDesignation',
      JSON.stringify(event.target.value),
    );
  };
  const handleDepartmentFilter = (event) => {
    setSelectedDepartment(event.target.value);
    localStorage.setItem(
      'kpiDepartment',
      JSON.stringify(event.target.value),
    );
  };
  const handlePerformancePeriodFilter = (event) => {
    setSelectPerformancePeriod(event.target.value);
    localStorage.setItem('kpiPerformance', JSON.stringify(event.target.value));
  };

  const handleSearchClick = async () => {
    try {
      const filter = {
        vertical: selectedVertical?.id,
        department: selectedDepartment?.id,
        designation: selectedDesignation?.id,
        performancePeriod: selectPerformancePeriod?.id,
      };

      const response = await fetchKpiDetails(filter);

      if (response.status === 200) {
        setNoDataMessage('');
        setKpiDetails(response.data.kpiDetails);
        setEditTarget(true);
      } else {
        setKpiDetails([]);
        setEditTarget(false);
        setNoDataMessage(response.noData);
      }
    } catch (error) {
      return [];
    }
  };

  useEffect(() => {
    if (selectedVertical?.id && selectedDepartment?.id && selectedDesignation?.id && selectPerformancePeriod?.id) {
      handleSearchClick();
    } else {
      setKpiDetails([]);
      setEditTarget(false);
      setNoDataMessage('');
    }
  }, [selectedVertical, selectedDepartment, selectedDesignation, selectPerformancePeriod]);
  const handleAccordionChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };
  const displayKPIdetails = () => {
    return kpiDetails.map((category, index) => (
      <Accordion
        expanded={expanded == `panel${index}`}
        onChange={handleAccordionChange(`panel${index}`)}
        key={category.kpiCategoryId}
        className='kpi-accordion'
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls={`panel${index}bh-content`}
          id={`panel${index}bh-header`}
          className='kpi-accordion-summary'
        >
          <Typography className='kpi-accordion-title'>
            {category.kpiCategory}
          </Typography>
        </AccordionSummary>
        <AccordionDetails className='kpi-accordion-details'>
          <table className='kpi-table'>
            <thead>
              <tr>
                <th className='kpi-column-heading'>Indicators</th>
                <th className='target-column-heading'>Suggested</th>
              </tr>
            </thead>
            <tbody>
              {category.kpiOptions.map((option) => (
                <tr key={option.kpiId} className='kpi-option-row'>
                  <td className='kpi-option-name'>{option.kpiName}</td>
                  <td className='kpi-option-target'>
                    {option.targetFormatValue} {option.targetValue}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </AccordionDetails>
      </Accordion>
    ));
  };

  const handleDialogOpen = () => {
    setDialogOpen(true);
    localStorage.removeItem('kpiVertical');
    localStorage.removeItem('kpiDepartment');
    localStorage.removeItem('kpiDesignation');
    localStorage.removeItem('kpiPerformance');
    localStorage.removeItem('kpiPreviousPerformance');
  };

  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  useEffect(() => {
    import('../../Assets/images/json/dar_no_data.json').then(
      ({ default: defAnimationData }) => {
        setAnimationData(defAnimationData);
      },
    );
  }, []);

  useEffect(() => {
    if (animationData) {
      lottie.loadAnimation({
        container: animationContainer.current,
        renderer: 'svg',
        loop: true,
        autoplay: true,
        animationData,
      });
    }
  }, [animationData]);

  return (
    <div className='manage-kpi-outer-layer'>
      <div className='manage-kpi-master'>
        <div className='manage-kpi-title'>
          {MANAGE_KPI_DASHBOARD.MANAGE_KPI}
        </div>
        <div className='main-container'>
          <div className='search-container'>
            <div className='autocomplete-container'>
              <div className='search-performance-container'>
                <MultiSelectSearchDropdown
                  mode='listbox'
                  dropdownCss='search-performance-period'
                  options={performancePeriodList}
                  value={selectPerformancePeriod}
                  onChange={handlePerformancePeriodFilter}
                  placeholder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.PERFORMANCE}
                  autoFocus={true}
                  size='small'
                  id='search-skill'
                  SearchPlaceHolder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.PERFORMANCE}
                  showFilterIcon={false}
                />
              </div>
              <div className='search-vertical-container'>
                <MultiSelectSearchDropdown
                  mode='listbox'
                  dropdownCss='search-vertical'
                  options={verticalList}
                  value={selectedVertical}
                  onChange={handleVerticalFilter}
                  placeholder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.VERTICAL}
                  autoFocus={true}
                  size='small'
                  id='search-skill'
                  SearchPlaceHolder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.VERTICAL}
                  showFilterIcon={false}
                />
              </div>
              <div className='search-department-container'>
                <MultiSelectSearchDropdown
                  mode='listbox'
                  dropdownCss='search-department'
                  options={department}
                  value={selectedDepartment}
                  onChange={handleDepartmentFilter}
                  placeholder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.DEPARTMENT}
                  autoFocus={true}
                  size='small'
                  id='search-skill'
                  SearchPlaceHolder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.DEPARTMENT}
                  showFilterIcon={false}
                />
              </div>
              <div className='search-designation-container'>
                <MultiSelectSearchDropdown
                  mode='listbox'
                  dropdownCss='search-designation'
                  options={designationList}
                  value={selectedDesignation}
                  onChange={handleDesignationFilter}
                  placeholder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.DESIGNATION}
                  autoFocus={true}
                  size='small'
                  id='search-skill'
                  SearchPlaceHolder={MANAGE_KPI_DASHBOARD.SELECT_PLACEHOLDER.DESIGNATION}
                  showFilterIcon={false}
                />
              </div>
            </div>
            <div className='manage-kpi-set-target'>
              {editTarget && (
                <ButtonComponent
                  disabled={!hasAccess('update')}
                  label={MANAGE_KPI_DASHBOARD.EDIT_TARGET}
                  variant='contained'
                  onClick={() => {
                    navigate('/configuration/manage-kpi/edit-kpi', { state: { kpiDetails } });
                  }}
                  startIcon={<EditIcon />}
                  btnCss='no-transform'
                ></ButtonComponent>
              )}
              <ButtonComponent
                disabled={!hasAccess('create')}
                label={MANAGE_KPI_DASHBOARD.SET_TARGET}
                variant='contained'
                onClick={handleDialogOpen}
                startIcon={<AddIcon />}
                btnCss='no-transform'
              ></ButtonComponent>
            </div>
          </div>
        </div>
        <div className='kpi-details-container'>
          {kpiDetails.length > 0 ? (
            displayKPIdetails()
          ) : !noDataMessage ? (
            <div className='search-icon-animation-container'>
              <div className='search-icon-animation-contents'>
                <div ref={animationContainer} className='search-icon-animation-image'></div>
                <Typography className='search-icon-animation-text'>
                  {MANAGE_KPI_DASHBOARD.SELECT_FILTERS_MSG}
                </Typography>
              </div>
            </div>
          ) : (
            <div className='no-data-container'>
              <img
                className='no-data-image'
                src={noKpiDataIcon}
                alt="No results found"
              />
            </div>
          )}
        </div>
        <KpiPerformanceCycle
          modalOpen={dialogOpen}
          handleClose={handleDialogClose}
        />
      </div>
    </div>
  );
};
export default ManageKpi;
